// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"b606880f","380":"192c3ac2","592":"1c503b9c"}[chunkId] + ".chunk.js";
};